const $cards = document.querySelectorAll('[data-role=serums-tab]');
const $cardsContent = document.querySelectorAll('[data-role=serums-tab-content]');

function activateTab(id) {
	const $tab = document.querySelector(`[data-role=serums-tab][data-serums-tab="${id}"]`);
	const $content = document.querySelector(`[data-role=serums-tab-content][data-serums-tab="${id}"]`);

	if (!$tab || !$content) return;

	$cards.forEach(c => c.classList.remove('_active'));
	$cardsContent.forEach(c => c.classList.remove('_active'));
	$tab.classList.add('_active');
	$content.classList.add('_active');
}

// Клик по табу — меняем URL
$cards.forEach($el => {
	$el.addEventListener('click', e => {
		e.preventDefault();

		const id = $el.getAttribute('data-serums-tab');
		
		history.replaceState(null, '', `#active-molecules-${id}`);
		activateTab(id);
	});
});

// При загрузке страницы — активируем нужную табу
window.addEventListener('DOMContentLoaded', () => {
	const hash = window.location.hash;
	if (!hash) return;

	const tabId = hash.replace('#active-molecules-', '');
	activateTab(tabId);
});

window.addEventListener('load', () => {
	const hash = window.location.hash;
	if (!hash || !hash.startsWith('#active-molecules-')) return;

	const $anchor = document.querySelector(hash);
	if (!$anchor) return;

	// Скроллим немного позже, чтобы всё успело отрендериться
	setTimeout(() => {
		const top = $anchor.getBoundingClientRect().top + window.scrollY;
		window.scrollTo({ top, behavior: 'smooth' });
	}, 1000);
});